import React from "react";
//#region types
import { BillingDetailsFieldProps } from "models/propTypes/timeReportingProjectPropTypes";
import { WintSuperkollAPIModelTimeReporting } from "wint-api-client/dist/types";
//#region components
import { Grid } from "@mui/material";
import { useTimeReportingProjectService } from "serviceHooks";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";

const BillingDetailsField: React.FC<BillingDetailsFieldProps> = (props) => {
  const timeReportingProjectService = useTimeReportingProjectService();
  const { text, individualBillingModel, showCurrentRate } = props;

  const currentDescriptionText = LocalizationHelperInstance.getFormattedMessage(
    TranslationKeys.TimeReportingProject.Current
  );
  const currentHourlyRateDescription = React.useMemo(() => {
    const currentHourlyRate = `(${currentDescriptionText} ${props.currentRate ?? 0} ${props.currency}/h)`;

    const descriptionText = `${currentHourlyRate}`;

    return descriptionText;
  }, [props.currentRate, props.hours]);

  const newHourlyRateDescription = React.useMemo(() => {
    const billingModelName = timeReportingProjectService.getMemberBillingModelText(individualBillingModel ?? 0);
    const hourlyRate = `${props.hourlyRate ?? 0} ${props.currency}/h`;
    const hours = props?.hours ?? 0; // update this field

    let descriptionText = `${billingModelName}, ${hourlyRate}`;

    if (individualBillingModel !== WintSuperkollAPIModelTimeReporting.TimeReportingPersonProjectBillingModel.Hourly) {
      descriptionText = `${descriptionText}, ${hours} h`;
    }

    return descriptionText;
  }, [individualBillingModel, props.hourlyRate, props.hours]);

  return (
    <Grid container item direction="column" className={clsx(cssExports.readOnlyField)}>
      <Grid item className={clsx(cssExports.fieldContent)}>
        {text}
        {individualBillingModel !== undefined && (
          <Grid item className={clsx(cssExports.formControlDescription)}>
            {newHourlyRateDescription}
          </Grid>
        )}
      </Grid>
      {individualBillingModel !== undefined && showCurrentRate && (
        <Grid item className={clsx(cssExports.formControlDescription)}>
          {currentHourlyRateDescription}
        </Grid>
      )}
    </Grid>
  );
};

export default BillingDetailsField;
